import React from 'react';
import { TextTitle, IconButton } from '@pypestream/design-system';
import './config-panel.scss';

export const ConfigPanel: React.FC<{
  title?: string | React.ReactNode;
  extra?: React.ReactNode;
  footer?: React.ReactNode;
  onClose?: () => void;
  children?: React.ReactNode;
}> = ({ title, extra, footer, onClose, children }) => (
  <div className="c-config-panel">
    {onClose && (
      <IconButton
        name="close"
        size="small"
        className="c-config-panel__close-button"
        onClick={onClose}
      />
    )}
    {(title || extra) && (
      <div className="c-config-panel__header">
        {title && (
          <TextTitle size="xsmall" className="c-config-panel__header-title">
            {title}
          </TextTitle>
        )}
        {extra && <div className="c-config-panel__header-extra">{extra}</div>}
      </div>
    )}
    <div className="c-config-panel__body">{children}</div>
    {footer && <div className="c-config-panel__footer">{footer}</div>}
  </div>
);
